export const THEME: string = 'light'

export const APP_LINKS = {
  ios: 'https://apps.apple.com/tr/app/bayku%C5%9F-yks-e%C4%9Fitim-dan%C4%B1%C5%9Fmanl%C4%B1%C4%9F%C4%B1/id6502242179?l=tr',
  android: 'https://play.google.com/store/apps/details?id=com.yksbogazici.owl&hl=tr'
}
export const WHATSAPP_URI: string = 'https://wa.me/902129459009 '
